module.exports = __webpack_public_path__ + "img/identify1.97524c0d.png";